import { render } from "./RegisterTournamentDialog.vue?vue&type=template&id=1058ecae"
import script from "./RegisterTournamentDialog.vue?vue&type=script&lang=js"
export * from "./RegisterTournamentDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__